const colors = {
  pureBlack: '#050505',
  black: '#0F0F0F',
  white: '#F0F0F0',
  blue: '#3BD8FB',
  hoverBlue: '#30B2CF',
  darkGrey: '#222222',
  lightGrey: '#DDDDDD',
  sidebarDark: '#2E2E2E',
  sidebarLight: '#EEEEEE'
}

export default colors